<template>
  
  <div class="card mb-25 border-0 rounded-0 welcome-lms-courses-box">
    <div
      class="card-body ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing"
    >
    
      <div class="row align-items-center">
        <div class="col-xxl-7">
          <div class="content">
            <span class="d-block fw-bold mb-5 text-white" id="current-date">
              {{ formattedDate }}
            </span>
            <h2 class="fw-semibold mb-8 text-white">
              Content de vous revoir <span class="fw-bold text-white"> </span>
            </h2>
            <p class="fs-md-15 fs-lg-16 text-white">
              Nous prenons en charge la gestion complete de votre backoffice
            </p>
            <div class="row list justify-content-center">
              <div
                class="col-lg-3 col-6 col-sm-3"
              >
                <div class="p-15 mt-15 bg-f2f1f9">
                  <span
                    class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase"
                  >
                    ARTICLE
                  </span>
                  <h5 class="mb-0 fw-black text-primary">
                    {{ totalActualites ? totalActualites : 0 }}
                  </h5>
                </div>
              </div>

              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-faf7f7">
                  <span  class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" >
                    BLOGS
                  </span>
                  <h5 class="mb-0 fw-black text-success">
                    0
                  </h5>
                </div>
              </div>

              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-ecf3f2">
                  <span  class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" >
                    PROJETS
                  </span>
                  <h5 class="mb-0 fw-black text-success">
                    0
                  </h5>
                </div>
              </div>

              <div class="col-lg-3 col-6 col-sm-3">
                <div class="p-15 mt-15 bg-f3f7f9">
                  <span  class="d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" >
                    BLOGS
                  </span>
                  <h5 class="mb-0 fw-black text-success">
                    0
                  </h5>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-xxl-5 text-center text-xxl-end mt-15 mt-md-0 ">
          <img
            src="../../../assets/images/welcomeImage.png"
            class="main-image"
            alt="welcome-image"
          />
        </div>
      </div>

    </div>

  </div>

  <div class="col-md-3">
    <div class="card bg-light-primary">
      <div class="card-body">
        <h5 class="card-title text-bold">Expiration</h5>
        <p class="card-text mb-1">La date d'expiration de l'abonnement est : 22-09-2026</p>
       
        <span class="badge bg-primary text-white fs-14"> 
          {{ daysLeftMessage }}
        </span>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import ApiService from "@/services/ApiService";
import { error } from "@/utils/utils";
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "WhatHappening",
  data() {
    return {
      updates: [
        {
          id: 1,
          bgClass: "bg-f2f1f9",
          title: "PUBLICATIONS",
          class: "text-primary",
          number: "0",
        },
        {
          id: 2,
          bgClass: "bg-faf7f7",
          title: "BLOGS",
          class: "text-danger",
          number: "0",
        },
        {
          id: 3,
          bgClass: "bg-ecf3f2",
          title: "ABONNEMENT",
          class: "text-success",
          number: "Actif",
        },
        {
          id: 4,
          bgClass: "bg-f3f7f9",
          title: " CODE AGENCE",
          class: "text-info",
          number: "02 BP 305",
        },
      ],
    };
  },
  setup() {
    const formattedDate = ref("");
    const daysLeftMessage = ref("");
    const months = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
    ];

    const currentDate = new Date();
    formattedDate.value = `${currentDate.getDate()}, ${ months[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    const totalActualites = ref(0);

    // Date d'expiration (22/09/2026)
    const expirationDate = new Date(2026, 8, 22); // Mois 8 = septembre (0-indexé)
    // Mettre à 00:00:00 pour éviter les problèmes d'heure
    expirationDate.setHours(0,0,0,0);
    currentDate.setHours(0,0,0,0);
    const diffTime = expirationDate.getTime() - currentDate.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 0) {
      daysLeftMessage.value = `${diffDays} jour${diffDays > 1 ? 's' : ''} restant.`;
    } else if (diffDays === 0) {
      daysLeftMessage.value = "L'abonnement expire aujourd'hui.";
    } else {
      daysLeftMessage.value = "L'abonnement a expiré.";
    }


    function getAll() {
      return ApiService.get(`/articles`)
        .then(({ data }) => {
          totalActualites.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => { error(response.data.message); });
    }

    onMounted( async () => {
      await getAll();
    });

    return {
      formattedDate,
      daysLeftMessage,
      totalActualites,
    };
  },
});
</script>